import { directionAPI } from '@/api'
import { jsonConvert } from '@/helpers/jsonConvert'

export const fetchCourseAndTariffs = async (
  id: number,
): Promise<ICourse | null> => {
  try {
    const res = await directionAPI.get({
      id,
      expand: [
        'directionTariffs.directionTariffNotices',
        'directionTariffs.tariffPeriods',
        'seniorSeminarians',
      ],
    })

    return {
      ...res.data,
      description: jsonConvert(res.data.description, 'json'),
      directionTariffs:
        res.data.directionTariffs?.map((item: ICourseTariff) => ({
          ...item,
          description: jsonConvert(item.description, 'json'),
        })) ?? [],
    }
  } catch (error) {
    console.error('Ошибка загрузки настроек курса:', error)
    return null
  }
}
